import { Card, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import Button from "../Button";
import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import FormField from "../../components/FormField";
import Typography from "../../components/Typography";
import Autocomplete from "../../components/Autocomplete";
import GroupService from "../../services/identity/group.service";
import CustomStatusCell from "../../components/CustomStatusCell";

import { ICodename } from "../../commons/interfaces";
import { Mode, Status } from "../../constants/enums";
import { IDataDetailGroup } from "../../containers/group/edit";
import { SelectMultiLanguage } from "../../components/MultiLanguage";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";


const CardGroupInfo = ({
    mode,
    newLableGroup,
    listParentGroup,

    dataRowsUserGroup,
    idGroupDefaultCompany,
    dataDetailGroupBackup,

    hidenStatus,
    hidenInputSelectGroupParent,
    requiredInputSelectGroupParent
}: {
    mode: number;
    newLableGroup?: string;
    listParentGroup?: ICodename[];

    dataRowsUserGroup?: any[];
    idGroupDefaultCompany?: string;
    dataDetailGroupBackup?: IDataDetailGroup;

    hidenStatus?: boolean;
    hidenInputSelectGroupParent?: boolean;
    requiredInputSelectGroupParent?: boolean;
}) => {
    const strings = useStrings();

    const {
        clientId, language, userInfo, listMultiLanguage,
        onError, onSuccess, onShowLoading, onHideLoading
    } = useCommonComponentContext();

    const [modeBasic, setModeBasic] = useState<number>(mode);
    const [valMultilanguage, setValMultilanguage] = useState<string>(language);
    const [dataDetailGroup, setDataDetailGroup] = useState<IDataDetailGroup>({});
    const [errorDetailGroup, setErrorDetailGroup] = useState<{ [key in keyof IDataDetailGroup]?: string }>({});

    useEffect(() => { setModeBasic(mode); }, [mode]);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(dataDetailGroupBackup?.id)) {
            setErrorDetailGroup({});
            setDataDetailGroup(dataDetailGroupBackup);
        }
    }, [dataDetailGroupBackup?.id]);

    const onChangeValue = async (newValue: any, key: string, isMultiLang?: boolean) => {
        setDataDetailGroup(prev => {
            let dataTemp: any = { ...prev };

            if (isMultiLang && isMultiLang === true) {
                dataTemp[key] = {
                    ...dataTemp[key],
                    value: {
                        ...dataTemp[key]?.value,
                        [valMultilanguage]: newValue
                    }
                };
            } else {
                dataTemp[key] = { value: newValue };
            }
            return dataTemp;
        });

        setErrorDetailGroup((prev: any) => ({
            ...prev,
            [key]: undefined,
        }))
    };

    const checkValidateDataGroup = () => {
        let isChecked = true;
        let newErr: any = { ...errorDetailGroup };

        if (Helpers.isNullOrEmpty(dataDetailGroup?.name?.value?.[valMultilanguage])) {
            newErr["name"] = strings.Common.REQUIRED;
            isChecked = false;
        }

        if (requiredInputSelectGroupParent
            && Helpers.isNullOrEmpty(dataDetailGroup.parentGroupId)) {
            newErr["parentGroupId"] = { error: strings.Common.REQUIRED };
            isChecked = false;
        }

        if (!isChecked) {
            setErrorDetailGroup(newErr);
        }

        return isChecked;
    };

    const handleUpdateGroup = async () => {
        if (!checkValidateDataGroup()) {
            return;
        } else {
            try {
                onShowLoading();

                const parentGroupId = Helpers.isNullOrEmpty(dataDetailGroup?.parentGroupId)
                    ? Helpers.isNullOrEmpty(idGroupDefaultCompany) ? undefined : idGroupDefaultCompany
                    : dataDetailGroup?.parentGroupId;

                const dataSubmit: any = {
                    clientId: clientId,
                    organizationId: userInfo?.userProfile?.organizationId,

                    isActive: Status.Active,
                    parentGroupId: parentGroupId,
                    name: Helpers.getDataMultiLanguage({
                        data: dataDetailGroup?.name,
                        currentLanguage: language,
                        listLanguage: listMultiLanguage,
                    }) || { value: { [language]: "" } },
                    description: Helpers.getDataMultiLanguage({
                        data: dataDetailGroup?.description,
                        currentLanguage: language,
                        listLanguage: listMultiLanguage,
                    }) || { value: { [language]: "" } },
                };

                // if (Helpers.isNullOrEmpty(dataDetailGroup?.id)) {
                //     await GroupService.create(dataSubmit);

                //     onSuccess(strings.format(strings.Group.CREATE_SUCCESS, newLableGroup));

                //     onGoBack();
                // } else {
                const newGroupUsers: any[] = [];

                [...dataRowsUserGroup || []].forEach((el) => {
                    newGroupUsers.push({
                        userId: el.userId,
                        manager: el.manager,
                        default: el.default,
                        userTitle: el.userTitle,
                        action: el.action,
                    });
                });

                await GroupService.update({
                    ...dataSubmit,
                    id: dataDetailGroup?.id,
                    groupUsers: newGroupUsers,
                    isActive: dataDetailGroup?.status,
                });

                setModeBasic(Mode.View);

                onSuccess(strings.format(strings.Group.UPDATE_SUCCESS, newLableGroup));
                // }

            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    const onCancel = () => {
        setModeBasic(Mode.View);

        setErrorDetailGroup({});

        dataDetailGroupBackup &&
            setDataDetailGroup({ ...dataDetailGroupBackup });
    };

    const onSubmit = () => {
        if (modeBasic === Mode.View) {
            setModeBasic(Mode.Update);
        } else {
            handleUpdateGroup();
        }
    }

    return (
        <Card>
            <Box p={2}>
                <Box sx={{
                    gap: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Box sx={{
                        gap: 1,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }} >
                        <Typography variant="h5">
                            {strings.format(strings.Group.BASIC_INFO, newLableGroup)}
                        </Typography>
                        {
                            !hidenStatus &&
                            !Helpers.isNullOrEmpty(dataDetailGroup?.id) &&
                            !Helpers.isNullOrEmpty(dataDetailGroup?.status) &&
                            <Box display="flex">
                                <CustomStatusCell isDetail status={dataDetailGroup?.status} />
                            </Box>
                        }
                    </Box>
                    {
                        (mode !== Mode.View) &&
                        !Helpers.isNullOrEmpty(dataDetailGroup?.id) &&
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}>
                            {
                                (modeBasic !== Mode.View) &&
                                <Button color="secondary" onClick={onCancel}>
                                    {strings.Common.CANCEL}
                                </Button>
                            }
                            <Button onClick={onSubmit}>
                                {(modeBasic === Mode.View) ? strings.Common.EDIT : strings.Common.SAVE}
                            </Button>
                        </Box>
                    }
                </Box>
                {
                    (modeBasic !== Mode.View) &&
                    <Box sx={{
                        marginTop: 2,
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "flex-end",
                    }}>
                        <SelectMultiLanguage
                            defaultLanguage={valMultilanguage}
                            onChangeLanguage={(value) => {
                                setDataDetailGroup({
                                    ...dataDetailGroup,
                                    name: Helpers.getDataMultiLanguage({
                                        data: dataDetailGroup?.name,
                                        currentLanguage: valMultilanguage,
                                        listLanguage: listMultiLanguage,
                                    }),
                                    description: Helpers.getDataMultiLanguage({
                                        data: dataDetailGroup?.description,
                                        currentLanguage: valMultilanguage,
                                        listLanguage: listMultiLanguage,
                                    }),
                                });
                                setValMultilanguage(value);
                            }}
                        />
                    </Box>
                }

                <Grid container spacing={3} p={2} pt={1}>
                    <Grid item xs={12} md={!hidenInputSelectGroupParent ? 6 : 12}>
                        <FormField
                            required
                            maxLength={255}
                            mode={modeBasic}
                            isFullRow={hidenInputSelectGroupParent}
                            errorMessage={errorDetailGroup?.name}
                            defaultValue={dataDetailGroup?.name?.value?.[valMultilanguage]}
                            placeholder={strings.format(strings.Group.ENTER_NAME_GROUP, newLableGroup)}
                            label={Helpers.capitalizeFirstLetter(strings.format(strings.Group.NAME_GROUP, newLableGroup))}
                            onBlur={(value) => onChangeValue(value, "name", true)}
                        />
                    </Grid>

                    {!hidenInputSelectGroupParent &&
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                mode={modeBasic}
                                data={listParentGroup || []}
                                required={requiredInputSelectGroupParent}
                                defaultValue={dataDetailGroup?.parentGroupId}
                                errorMessage={errorDetailGroup?.parentGroupId}
                                placeholder={strings.format(strings.Group.SELECT_GROUP_PARENT, newLableGroup)}
                                label={Helpers.capitalizeFirstLetter(strings.format(strings.Group.GROUP_PARENT, newLableGroup))}
                                onChange={(value) => onChangeValue(value, "parentGroupId")}
                            />
                        </Grid>
                    }

                    <Grid item xs={12} md={12}>
                        <FormField
                            isFullRow
                            multiline
                            maxLength={255}
                            mode={modeBasic}
                            label={strings.Organization.DESCRIPTION}
                            placeholder={strings.Organization.ENTER_DESCRIPTION}
                            defaultValue={dataDetailGroup?.description?.value?.[valMultilanguage]}
                            onBlur={(value) => onChangeValue(value, "description", true)}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default CardGroupInfo;